export default "__VITE_ASSET__a6621f2f__"